module.exports = __webpack_public_path__ + "3266bfc628bb022850d3f1950c5727e7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/hoodie-finger-heart-brown-s.png
// module id = 1862
// module chunks = 0